import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography, Button, TextField } from '@mui/material';
import { QrReader } from 'react-qr-reader';

const QrLoginModal = ({ open, onClose, onScanSuccess }) => {
  const [manualQr, setManualQr] = useState('');

  useEffect(() => {
    if (open) {
      setManualQr('');
    }
  }, [open]);

  const handleScan = (data) => {
    if (data) {
      onScanSuccess(data);
      onClose();
    }
  };

  const handleError = (err) => {
    console.error('Erro no QR Reader:', err);
  };

  const handleManualSubmit = () => {
    if (manualQr) {
      onScanSuccess(manualQr);
      onClose();
    }
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          width: { xs: '90%', sm: '400px' },
        }}
      >
        <Typography variant="h6" align="center" gutterBottom>
          Login com QR Code
        </Typography>
        <QrReader
          delay={300}
          onError={handleError}
          onScan={handleScan}
          style={{ width: '100%' }}
        />
        <Typography variant="body2" align="center" sx={{ mt: 2 }}>
          Ou insira o código manualmente:
        </Typography>
        <TextField
          fullWidth
          type="password"
          value={manualQr}
          onChange={(e) => setManualQr(e.target.value)}
          placeholder="Digite o código QR"
          sx={{ mt: 1 }}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              handleManualSubmit();
            }
          }}
        />
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
          <Button variant="outlined" onClick={handleManualSubmit}>
            Entrar
          </Button>
        </Box>
        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
          <Button variant="outlined" onClick={onClose}>
            Cancelar
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default QrLoginModal;
